import React from "react";

const Weight = (props) => (
  <svg
    xmlSpace="preserve"
    width="30px"
    height="30px"
    viewBox="0 0 512 512"
    {...props}
  >
    <path
      d="M469.332.004H42.668C19.101.004 0 19.104 0 42.673v426.655c0 23.567 19.101 42.668 42.668 42.668h426.664c23.567 0 42.668-19.101 42.668-42.668V42.673C512 19.104 492.899.004 469.332.004M364.37 191.877h-65.293l11.409-68.16-10.592-2.15-10.6-2.167-17.443 72.477H147.63l-28.151-81.902c39.867-24.026 86.578-37.868 136.529-37.868 49.943 0 96.645 13.842 136.513 37.868z"
    />
  </svg>
);

export default Weight;
